import styled from 'styled-components';
import TxtField02 from 'dc/TxtField02';
import Btn021 from 'dc/Btn021';
import { Typ41, Typ30, Typ20 } from 'dc/Typ';

export const Container = styled.div`
  width: 458px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  height: 504px;
  margin-top: 50px;
  padding: 56px 86px 68px 86px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const Title = styled(Typ41)`
  margin-bottom: 12px;
`;

export const Text = styled(Typ30)`
  color: #607d8b;
  width: 100%;
  margin-top: -32px;
  margin-bottom: 22px;
  display: block;
`;

export const PasswordInput = styled(TxtField02)`
  margin-bottom: 4px;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #f4f7f9 inset !important;
  }
`;

export const Button = styled(Btn021)`
  width: 100%;
  height: 40px;
`;

export const Error = styled(Typ20)`
  color: #d9464d;
  margin-bottom: 22px;
  display: block;
`;
